export const invoiceListTab = {
  NOT_PAID: 'NOT_PAID',
  CREATED: 'CREATED',
  FP_PROCESSED: 'FP_PROCESSED',
  FP_FINISHED: 'FP_FINISHED',
  FP_REVIEWED: 'FP_REVIEWED',
  TTF_PROCESSED: 'TTF_PROCESSED',
  READY_TO_SEND: 'READY_TO_SEND',
  SENT: 'SENT',
  FINISHED_TF: 'FINISHED_TF',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID',
  FINISHED: 'FINISHED'
}
